import {isOnboardingGenerateWorkspaceStepEnabled} from '@toolify/server/src/enum/isOnboardingGenerateWorkspaceStepEnabled'
import {OnboardingStepType} from '@toolify/server/src/enum/OnboardingStepType'
import {IOnboardingStepMetadata} from '@toolify/client/src/modules/onboarding/types/IOnboardingStepMetadata'
import {MdsThumbnailVisualType} from '@toolify/client/src/modules/mds/enum/MdsThumbnailVisualType'

export const onboardingStepMetadataMap = new Map<OnboardingStepType, IOnboardingStepMetadata>([
  [OnboardingStepType.WorkspaceCustomization, {
    titleKey: 'onboarding.steps.workspace-customization',
    graphicVisual: MdsThumbnailVisualType.Collage,
    graphicHeadlineKey: 'onboarding.graphic.headlines.workspace-customization',
    graphicSceneTitleKey: 'onboarding.graphic.modernHeadlines.workspace-customization',
    graphicSceneSubtitleKey: 'onboarding.graphic.sublines.workspace-customization',
  }],
  [OnboardingStepType.CompanyInfo, {
    titleKey: 'onboarding.steps.company-info',
    graphicVisual: MdsThumbnailVisualType.Map,
    graphicHeadlineKey: 'onboarding.graphic.headlines.company-info',
    graphicSceneTitleKey: 'onboarding.graphic.modernHeadlines.company-info',
    graphicSceneSubtitleKey: 'onboarding.graphic.sublines.company-info',
  }],
  [OnboardingStepType.CoreAreas, {
    titleKey: 'onboarding.steps.core-areas',
    graphicVisual: MdsThumbnailVisualType.Kanban,
    graphicHeadlineKey: 'onboarding.graphic.headlines.core-areas',
    graphicSceneTitleKey: 'onboarding.graphic.modernHeadlines.core-areas',
    graphicSceneSubtitleKey: 'onboarding.graphic.sublines.core-areas',
  }],
  [OnboardingStepType.Solutions, {
    titleKey: 'onboarding.steps.solutions',
    graphicVisual: MdsThumbnailVisualType.Gantt,
    graphicHeadlineKey: 'onboarding.graphic.headlines.solutions',
    graphicSceneTitleKey: 'onboarding.graphic.modernHeadlines.solutions',
    graphicSceneSubtitleKey: 'onboarding.graphic.sublines.solutions',
  }],
  [OnboardingStepType.Invite, {
    titleKey: 'onboarding.steps.invite',
    graphicVisual: MdsThumbnailVisualType.Roles,
    graphicHeadlineKey: 'onboarding.graphic.headlines.invite',
    graphicSceneTitleKey: 'onboarding.graphic.modernHeadlines.invite',
    graphicSceneSubtitleKey: 'onboarding.graphic.sublines.invite',
  }],
  [OnboardingStepType.RoleAndDiscover, {
    titleKey: 'onboarding.steps.role-and-discover',
    graphicVisual: MdsThumbnailVisualType.Files,
    graphicHeadlineKey: 'onboarding.graphic.headlines.role-and-discover',
    graphicSceneTitleKey: 'onboarding.graphic.modernHeadlines.role-and-discover',
    graphicSceneSubtitleKey: 'onboarding.graphic.sublines.role-and-discover',
  }],
  [OnboardingStepType.GenerateWorkspace, {
    titleKey: 'onboarding.steps.generate-workspace',
    graphicVisual: MdsThumbnailVisualType.Collage,
    graphicHeadlineKey: 'onboarding.graphic.headlines.generate-workspace',
    graphicSceneTitleKey: 'onboarding.graphic.modernHeadlines.generate-workspace',
    graphicSceneSubtitleKey: 'onboarding.graphic.sublines.generate-workspace',
  }],
  [OnboardingStepType.ProfileCustomization, {
    titleKey: 'onboarding.steps.profile-customization',
    graphicVisual: MdsThumbnailVisualType.Files,
    graphicHeadlineKey: 'onboarding.graphic.headlines.profile',
    graphicSceneTitleKey: 'onboarding.graphic.modernHeadlines.profile',
    graphicSceneSubtitleKey: 'onboarding.graphic.sublines.profile',
  }],
])

export const onboardingStepOrder: OnboardingStepType[] = Array.from(onboardingStepMetadataMap.keys())
  .filter(step => isOnboardingGenerateWorkspaceStepEnabled || step !== OnboardingStepType.GenerateWorkspace)

export const userLevelOnboardingSteps: OnboardingStepType[] = [
  OnboardingStepType.RoleAndDiscover,
  OnboardingStepType.ProfileCustomization,
]

export function isUserLevelOnboardingStep(step: OnboardingStepType): boolean {
  return userLevelOnboardingSteps.includes(step)
}
